import { render, staticRenderFns } from "./addPackage.vue?vue&type=template&id=9fca6a9e"
import script from "./addPackage.vue?vue&type=script&lang=js"
export * from "./addPackage.vue?vue&type=script&lang=js"
import style0 from "./addPackage.vue?vue&type=style&index=0&id=9fca6a9e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_qhqm3mauky62uixplfzayyuc5e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports